import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomTable from "../../../components/table/table";
import "./view.css";
import {
  admin_final_acceptance_status,
  admin_update_revert_status,
  admin_update_revert_status_touser,
  cfo_update_payment_status,
  get_resourse_details,
  get_vendor_details,
  sa_update_revert_status,
  sa_update_vendor_status,
  update_resourse_status,
  update_vendor_status,
  vendor_cfo_revert,
} from "../admin.api";
import Snackbar from "../../../components/snackbar/snackbar";
import Loader from "../../../components/loader/loader";
import jwtDecode from "jwt-decode";
import Swal from "sweetalert2";
import moment from "moment";
export default function View(props) {
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [url, setUrl] = useState("");
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const handleEdit = () => {};
  const handleDownload = (item) => {
    let path = `${result}${item.file_upload_certificate}`;
    window.open(path, "_blank");
  };
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const selectedParam = useParams();
  const getDetails = (id) => {
    get_vendor_details(id).then((res) => {
      let tdata = res.data;

      setData(tdata);
      setIsActive(false);
    });
  };
  useEffect(() => {
    getDetails(selectedParam.id);
  }, []);
  const handleDownloadBiodata = () => {
    let path = `${result}${data.biodata}`;
    window.open(path, "_blank");
  };
  const handleDownloadExpCert = (data) => {
    let path = `${result}${data}`;
    window.open(path, "_blank");
  };

  const saMessage = (status) => {
    Swal.fire({
      title: "Message",
      input: "textarea",
      showCancelButton: false,
      confirmButtonColor: "#0A223D",
      confirmButtonText: "Submit",
      inputAttributes: {
        "aria-label": "Type your message here",
      },
      inputValidator: (value) => {
        if (!value) {
          return "Please describe the reason";
        }
      },
      showCancelButton: true,
    }).then((message) => {
      if (message.isConfirmed === true) {
        let rpdetails = data?.id;
        let rdata = {};
        if (adminType === 1) {
          rdata =
            status === 1
              ? { message: message.value }
              : { user_message: message.value };
        } else {
          rdata = { sadmin_reason: message.value };
        }

        setIsActive(true);

        sa_update_revert_status(rdata, data?.id)
          .then((res) => {
            setSnackMessage(res.message);
            setIsSnackError(false);
            setSnackOpen(true);
            setIsActive(false);
          })
          .catch((error) => {
            setSnackMessage(error.message);
            setIsSnackError(true);
            setSnackOpen(true);
            setIsActive(false);
          });
      } else {
        setSnackMessage("You do not have permission to perform this action.");
        setIsSnackError(true);
        setSnackOpen(true);
      }
    });
  };
  const adminRevert = (status) => {
    Swal.fire({
      inputLabel: "Message",
      input: "textarea",
      showCancelButton: false,
      confirmButtonColor: "#0A223D",
      confirmButtonText: "Submit",
      inputAttributes: {
        "aria-label": "Type your message here",
      },
      inputValidator: (value) => {
        if (!value) {
          return "Please describe the reason";
        }
      },
      showCancelButton: true,
    }).then((message) => {
      if (message.isConfirmed === true) {
        let rpdetails = data?.id;
        let rdata = {};

        rdata = { admin_reason: message.value };

        setIsActive(true);
        if (adminType === 1) {
          admin_update_revert_status_touser(rdata, data.id)
            .then((res) => {
              setSnackMessage(res.message);
              setIsSnackError(false);
              setSnackOpen(true);
              setIsActive(false);
            })
            .catch((error) => {
              setSnackMessage(error.message);
              setIsSnackError(true);
              setSnackOpen(true);
              setIsActive(false);
            });
        }
      }
    });
  };
  const cfoRevert = (status) => {
    Swal.fire({
      inputLabel: "Message",
      input: "textarea",
      showCancelButton: false,
      confirmButtonColor: "#0A223D",
      confirmButtonText: "Submit",
      inputAttributes: {
        "aria-label": "Type your message here",
      },
      inputValidator: (value) => {
        if (!value) {
          return "Please describe the reason";
        }
      },
      showCancelButton: true,
    }).then((message) => {
      if (message.isConfirmed === true) {
        let rpdetails = data?.id;
        let rdata = {};

        rdata = { cfo_message: message.value };

        setIsActive(true);
        if (adminType === 23) {
          vendor_cfo_revert(rdata, data.id)
            .then((res) => {
              setSnackMessage(res.message);
              setIsSnackError(false);
              setSnackOpen(true);
              setIsActive(false);
            })
            .catch((error) => {
              setSnackMessage(error.message);
              setIsSnackError(true);
              setSnackOpen(true);
              setIsActive(false);
            });
        }
      }
    });
  };

  const handleAdminActions = (status) => {
    if (adminType === 23) {
      Swal.fire({
        title: "Upload Receipt",
        input: "file",
        showCancelButton: true,
        confirmButtonColor: "#0A223D",
        confirmButtonText: "Submit",
        inputAttributes: {
          "aria-label": "Upload your receipt",
          accept: ".jpg,.jpeg,.png,.pdf",
        },
        didOpen: () => {
          const confirmBtnContainer = document.querySelector(".swal2-actions");
          const helper = document.createElement("div");
          helper.className = "file-up-helper-new";
          helper.innerHTML =
            "*Upload only .pdf format and Size should be less than 1MB";
          confirmBtnContainer?.parentNode?.insertBefore(
            helper,
            confirmBtnContainer
          );
        },
        inputValidator: (value) => {
          if (!value) {
            return "Please upload a receipt.";
          }
        },
      }).then((message) => {
        if (message.isConfirmed) {
          const fileInput = document.querySelector(".swal2-file");
          const file = fileInput?.files[0];

          if (file) {
            let formData = new FormData();
            formData.append("status", status);
            formData.append("receipt", file);

            setIsActive(true);

            cfo_update_payment_status(formData, data?.id)
              .then((res) => {
                setSnackMessage(res.message);
                setIsSnackError(false);
                setSnackOpen(true);
                setIsActive(false);
              })
              .catch((error) => {
                setSnackMessage(error.message);
                setIsSnackError(true);
                setSnackOpen(true);
                setIsActive(false);
              });
          } else {
            setSnackMessage("No receipt uploaded. Action canceled.");
            setIsSnackError(true);
            setSnackOpen(true);
          }
        }
      });
    } else {
      Swal.fire({
        inputLabel: "Message",
        input: "textarea",
        showCancelButton: false,
        confirmButtonColor: "#0A223D",
        confirmButtonText: "Submit",
        inputAttributes: {
          "aria-label": "Type your message here",
        },
        inputValidator: (value) => {
          if (!value) {
            return "Please specify the message ";
          }
        },
        showCancelButton: true,
      }).then((message) => {
        if (message.isConfirmed === true) {
          let rdata = { status: status, sadmin_reason: message.value };
          setIsActive(true);

          if (adminType === 2) {
            sa_update_vendor_status(rdata, data?.id)
              .then((res) => {
                setSnackMessage(res.message);
                setIsSnackError(false);
                setSnackOpen(true);
                setIsActive(false);
              })
              .catch((error) => {
                setSnackMessage(error.message);
                setIsSnackError(true);
                setSnackOpen(true);
                setIsActive(false);
              });
          }
        }
      });
    }
  };

  const adminFinalApprove = (status) => {
    let rdata = { status: status };
    admin_final_acceptance_status(rdata, data?.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const adminAcceptance = (status) => {
    Swal.fire({
      inputLabel: "Message",
      input: "textarea",
      showCancelButton: false,
      confirmButtonColor: "#0A223D",
      confirmButtonText: "Submit",
      inputAttributes: {
        "aria-label": "Type your message here",
      },
      inputValidator: (value) => {
        if (!value) {
          return "Please specify the message ";
        }
      },
      showCancelButton: true,
    }).then((message) => {
      if (message.isConfirmed === true) {
        let rdata = { status: status, admin_reason: message.value };

        update_vendor_status(rdata, data?.id)
          .then((res) => {
            setSnackMessage(res.message);
            setIsSnackError(false);
            setSnackOpen(true);
            setIsActive(false);
          })
          .catch((error) => {
            setSnackMessage(error.message);
            setIsSnackError(true);
            setSnackOpen(true);
            setIsActive(false);
          });
      }
    });
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/vendors-list");
    }
  };
  const arrayToString = (data) => {
    var replace = data.replace(/[["'\]]/g, " ");
    var array = replace.split(",");
    return array;
  };
  return (
    <div>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <Loader open={isActive} />
      <div className="view-container">
        <span className="d-flex justify-content-between">
          <h6 className="mb-0 pt-2">
            <b>Vendor Details</b>
          </h6>

          <button
            type="button"
            className="btn btn-primary"
            onClick={(e) => {
              props.history.push("/vendors-list");
            }}
          >
            Back
          </button>
        </span>
        <hr />
        {/* <button
          type="button"
          className="btn btn-secondary btn-sm  mb-3"
          onClick={(e) => {
            props.history.push("/event-list/");
          }}
        >
          Back
        </button> */}
        <div className="data">
          <div className="row">
            <div className="col-3">Company Name</div>
            <div className="col-1">:</div>
            <div className="col-7 break-word">{data?.company_name}</div>
          </div>
          <div className="row">
            <div className="col-3">Application Ref No</div>
            <div className="col-1">:</div>
            <div className="col-7 break-word">{data?.unique_application_ref_no}</div>
          </div>
          <div className="row">
            <div className="col-3">Address</div>
            <div className="col-1">:</div>
            <div className="col-7 break-word">{data?.address}</div>
          </div>
          {data?.logo && (
            <div className="row">
              <div className="col-3"> Logo</div>
              <div className="col-1">:</div>
              <div className="col-7 ">
                <img
                  className="res_photo"
                  src={`${result}${data?.logo}`}
                  alt=""
                />
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-3">Area of Operation/Expertise</div>
            <div className="col-1">:</div>
            <div className="col-7 break-word">{data?.area_of_operation}</div>
          </div>
          <div className="row">
            <div className="col-3">Brief Company Description</div>
            <div className="col-1">:</div>
            <div className="col-7  break-word">{data?.company_description}</div>
          </div>
          <div className="row">
            <div className="col-3">Contact Person Name</div>
            <div className="col-1">:</div>
            <div className="col-7 break-word">{data?.name}</div>
          </div>

          <div className="row">
            <div className="col-3">Contact Number</div>
            <div className="col-1">:</div>
            <div className="col-7">{data?.phone}</div>
          </div>
          <div className="row">
            <div className="col-3">Email</div>
            <div className="col-1">:</div>
            <div className="col-7">{data?.email}</div>
          </div>
          {data?.alternate_phone && data?.alternate_phone !== "null" && (
            <div className="row">
              <div className="col-3">Alternate Contact Number</div>
              <div className="col-1">:</div>
              <div className="col-7">{data?.alternate_phone}</div>
            </div>
          )}

          {data?.alternate_email && data?.alternate_email !== "null" && (
            <div className="row">
              <div className="col-3">Alternate Email</div>
              <div className="col-1">:</div>
              <div className="col-7">{data?.alternate_email}</div>
            </div>
          )}
          {data?.status == 5 && (
            <div className="row">
              <div className="col-3">Accepted at</div>
              <div className="col-1">:</div>
              <div className="col-7">
                {data?.updated_at
                  ? moment(data?.updated_at).format("DD-MM-YYYY")
                  : ""}
              </div>
            </div>
          )}
          {data?.tran_id && (
            <div className="row">
              <div className="col-3">Transaction ID</div>
              <div className="col-1">:</div>
              <div className="col-7">{data?.tran_id ?? ""}</div>
            </div>
          )}
          {data?.utr_no && (
            <div className="row">
              <div className="col-3">UTR No</div>
              <div className="col-1">:</div>
              <div className="col-7">{data?.utr_no ?? ""}</div>
            </div>
          )}
          {data?.tran_date && (
            <div className="row">
              <div className="col-3">Transaction Date</div>
              <div className="col-1">:</div>
              <div className="col-7">
                {data?.tran_date
                  ? moment(data?.tran_date).format("DD-MM-YYYY")
                  : ""}
              </div>
            </div>
          )}
          {data?.bank_name && (
            <div className="row">
              <div className="col-3">Bank Name</div>
              <div className="col-1">:</div>
              <div className="col-7">{data?.bank_name ?? ""}</div>
            </div>
          )}
          {data?.payment_mode && (
            <div className="row">
              <div className="col-3">Payment Mode</div>
              <div className="col-1">:</div>
              <div className="col-7">{data?.payment_mode ?? ""}</div>
            </div>
          )}
          {data?.amount && (
            <div className="row">
              <div className="col-3">Transaction Amount</div>
              <div className="col-1">:</div>
              <div className="col-7">{data?.amount ?? ""}</div>
            </div>
          )}
          {data?.subscription_start_date && (
            <div className="row">
              <div className="col-3">Subscription Start Date</div>
              <div className="col-1">:</div>
              <div className="col-7">{data?.subscription_start_date ?? ""}</div>
            </div>
          )}
          {data?.subscription_end_date && (
            <div className="row">
              <div className="col-3">Subscription End Date</div>
              <div className="col-1">:</div>
              <div className="col-7">{data?.subscription_end_date ?? ""}</div>
            </div>
          )}
          {data?.amount && (
            <div className="row">
              <div className="col-3">Duration</div>
              <div className="col-1">:</div>
              <div className="col-7">{data?.amount > 8000 ? "5 Year" : "1 Year"}</div>
            </div>
          )}

          {/* {data?.status == 5 && (
            <div className="row">
              <div className="col-3">Accepted at</div>
              <div className="col-1">:</div>
              <div className="col-7">
                {data?.updated_at ? moment().format("DD-MM-YYYY") : ""}
              </div>
            </div>
          )}
          {data?.status == 5 && (
            <div className="row">
              <div className="col-3">Accepted at</div>
              <div className="col-1">:</div>
              <div className="col-7">
                {data?.updated_at ? moment().format("DD-MM-YYYY") : ""}
              </div>
            </div>
          )} */}
          {data?.sadmin_reason && (
            <div className="row">
              <div className="col-3">Super Admin Message</div>
              <div className="col-1">:</div>
              <div className="col-7">{data?.sadmin_reason}</div>
            </div>
          )}
          {data?.admin_reason && (
            <div className="row">
              <div className="col-3">Admin Message</div>
              <div className="col-1">:</div>
              <div className="col-7">{data?.admin_reason}</div>
            </div>
          )}
          {data?.cfo_message && (
            <div className="row">
              <div className="col-3">CFO Reverted Reason</div>
              <div className="col-1">:</div>
              <div className="col-7">{data?.cfo_message}</div>
            </div>
          )}

          {data?.brochure && (
            <div className="row">
              <div className="col-3"> Brochure</div>
              <div className="col-1">:</div>
              <div className="col-7">
                <button
                  className="btn btn-approve btn-success"
                  onClick={(e) => handleDownloadExpCert(data?.brochure)}
                >
                  Download File
                </button>
              </div>
            </div>
          )}
          {data?.reciept && (
            <div className="row">
              <div className="col-3">Receipt</div>
              <div className="col-1">:</div>
              <div className="col-7">
                <button
                  className="btn btn-approve btn-success"
                  onClick={(e) => handleDownloadExpCert(data?.reciept)}
                >
                  Download File
                </button>
              </div>
            </div>
          )}

          {adminType === 1 && (
            <>
              <div className="d-flex justify-content-center mt-5">
                {(data?.status === 0 || data?.status === 8) && (
                  <button
                    type="button"
                    className="btn btn-approve btn-success mr-2"
                    onClick={() => adminAcceptance()}
                  >
                    Submit for Acceptance
                  </button>
                )}
                {(data?.status === 6 || data?.status === 0 || data?.status === 8) && (
                  <button
                    type="button"
                    className="btn btn-approve btn-success mr-2"
                    onClick={(e) => adminRevert()}
                  >
                    Revert to User
                  </button>
                )}
                {data?.status === 4 && (
                  <button
                    type="button"
                    onClick={(e) => adminFinalApprove()}
                    className="btn btn-approve btn-success mr-2"
                  >
                    Approve
                  </button>
                )}
                {/* <button type="button" className="btn btn-reject btn-danger">
                    Reject
                  </button> */}
              </div>
            </>
          )}
          {adminType === 2 && (
            <>
              {(data?.status === 1 || data?.status === 8)&& (
                <div className="d-flex justify-content-center">
                  <button
                    type="button"
                    onClick={(e) => handleAdminActions(2)}
                    className="btn btn-approve btn-success mr-2"
                  >
                    Approved for payment collection
                  </button>
                  <button
                    type="button"
                    onClick={(e) => saMessage(3)}
                    className="btn btn-reject  btn-danger "
                  >
                    Revert
                  </button>
                  <br />
                </div>
              )}
            </>
          )}
          {adminType === 23 && (
            <>
              {data?.status === 3 && (
                <>
                  <div className="d-flex justify-content-center">
                    <button
                      type="button"
                      onClick={(e) => handleAdminActions(3)}
                      className="btn btn-approve btn-success mr-2"
                    >
                      Confirm Payment
                    </button>
                    <button
                      type="button"
                      onClick={(e) => cfoRevert()}
                      className="btn btn-reject btn-danger mr-2"
                    >
                      Revert
                    </button>
                    <br />
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
